import { axiosConfig } from '../api/axios-config.js'

// AI 文件管理
export const aiDocument = {
  // 取得文件列表
  list: (params, token) => axiosConfig.get('/api/ai/documents', {
    ...token,
    params
  }),

  // 上傳文件
  upload: (formData, token, onUploadProgress) => axiosConfig.post('/api/ai/documents/upload', formData, {
    ...token,
    onUploadProgress
  }),

  // 取得單筆文件詳情
  show: (id, token) => axiosConfig.get(`/api/ai/documents/${id}`, token),

  // 取得處理狀態
  status: (id, token) => axiosConfig.get(`/api/ai/documents/${id}/status`, token),

  // 重新處理
  reprocess: (id, token) => axiosConfig.post(`/api/ai/documents/${id}/reprocess`, {}, token),

  // 刪除文件
  destroy: (id, token) => axiosConfig.delete(`/api/ai/documents/${id}`, token)
}
